import React from 'react';
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error('ErrorBoundary caught:', error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
          <div className="text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-serif font-semibold text-[#1F4D3F] mb-2">Une erreur s'est produite</h2>
          <p className="text-[#7A6F5C] mb-6 max-w-md">Quelque chose s'est mal passé. Veuillez rafraîchir la page.</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            className="bg-[#1F4D3F] text-white px-6 py-2.5 rounded-xl font-medium hover:bg-[#173B30]">
            Rafraîchir la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
